import CalculatorIndex from './Index'
import CalculatorView from './View'

export default [
  {
    path: '/calculator',
    name: 'calculator',
    component: CalculatorIndex,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
  {
    path: '/calculator/:energetic/:type',
    name: 'calculatorView',
    component: CalculatorView,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
]
